import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './icons';
import { colors } from '@styles/theme';

export const themes = {
  default: {
    color: colors.black
  },
  info: {
    color: colors.primary,
    icon: InfoIcon
  },
  success: {
    color: colors.green,
    icon: SuccessIcon
  },
  warning: {
    color: colors.gold,
    icon: WarningIcon
  },
  error: {
    color: colors.red,
    icon: ErrorIcon
  }
};

export function getTheme(name) {
  return themes[name] || themes.default;
}

export const themeNames = Object.keys(themes);
